module.exports = __webpack_public_path__ + "assets/202509252035/img/Tobin.b36ad548.jpg";